package com.hyperether.goodjob.repository.remote.model

import com.hyperether.goodjob.models.AssigneesRequest
import com.hyperether.goodjob.models.Note
import com.hyperether.goodjob.models.Step
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class JobRequest(
    @SerialName("jobTitle") var jobTitle: String? = null,
    @SerialName("status") var status: String? = null,
    @SerialName("assignees") var assignees: AssigneesRequest? = null,
    @SerialName("creatorId") var creatorId: String? = null,
    @SerialName("workspaceId") var workspaceId: String? = null,
    @SerialName("start_at") var start_at: String? = null,
    @SerialName("end_at") var end_at: String? = null,
    @SerialName("repeat") var repeat: String? = null,
    @SerialName("startDate") var startDate: String? = null,
    @SerialName("dueDate") var dueDate: String? = null,
    @SerialName("jobDuration") var jobDuration: Long? = null,
    @SerialName("repeatInterval") var repeatInterval: List<String?>? = null,
    @SerialName("steps") var steps: List<Step?> = emptyList(),
    @SerialName("userId") var userId: String? = null,
    @SerialName("contactSiteId") var contactSiteId: String? = null,
    @SerialName("contactSiteName") var contactSiteName: String? = null,
    @SerialName("contactParentId") var contactParentId: String? = null,
    @SerialName("createdAt") var createdAt: Long? = null,
    @SerialName("updatedAt") var updatedAt: Long? = null,
    @SerialName("notes") var notes: String? = null,
    @SerialName("fileId") var fileId: String? = null,
    @SerialName("files") var files: List<String?>? = null,
    @SerialName("fileObjects") var fileObjects: List<FileObject?>? = null,
    @SerialName("noteObjects") var noteObjects: List<Note>? = null
)